import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'
import index from './reducer'

const composeEnhancers = composeWithDevTools({})

const store = createStore(
  index,
  composeEnhancers(applyMiddleware(thunk))
)

export default store
